import { ICpwEnvironment } from './ICpwEnvironment';

export const environment: ICpwEnvironment = {
    production: true,
    environment: 'prod',
    mainUrl: 'https://parts.controltower.tech',
    bffUrl: 'https://parts.api.controltower.tech',
    auth0ClientId: '22cHiuVeEuliKZIyAhYBjI9EL503iFtJ',
    auth0AuthParams: {
        organization: 'org_6b2XkZhbX4CIXMAE',
        redirect_uri: 'https://parts.controltower.tech/public/login-callback',
    },
    dataDog: {
        applicationId: 'ff0a67f4-06f7-41e5-beb6-d692fba1f1bf',
        clientToken: 'puba4ab754200220f6fc4ec64563e041ff9',
        service: 'cpw-ui',
    },
};
